import { SizeProp } from "@fortawesome/fontawesome-svg-core";
import {
  faBus,
  faShip,
  faSubway,
  faTrain,
  faTrainTram,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { TransportType } from "../types/line";

export function TransportIcon({
  transportType,
  size = "sm",
}: {
  transportType: TransportType;
  size?: SizeProp;
}) {
  switch (transportType) {
    case "BUS":
      return <FontAwesomeIcon icon={faBus} size={size} />;
    case "METRO":
      return <FontAwesomeIcon icon={faSubway} size={size} />;
    case "TRAIN":
      return <FontAwesomeIcon icon={faTrain} size={size} />;
    case "TRAM":
      return <FontAwesomeIcon icon={faTrainTram} size={size} />;
    case "SHIP":
      return <FontAwesomeIcon icon={faShip} size={size} />;
    default:
      return null;
  }
}
